import axios, { AxiosInstance } from "axios";
import { refreshToken, logoutUser, getAccessToken } from "./AuthService";

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8080/api/v1";

export const createAxiosInstance = (baseURL?: string): AxiosInstance => {
  const finalBaseURL = baseURL || API_BASE_URL;

  if (!finalBaseURL) {
    throw new Error(
      "Base URL is undefined. Please provide a valid API base URL.",
    );
  }

  const instance = axios.create({
    baseURL: finalBaseURL,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = getAccessToken();
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        const newAccessToken = await refreshToken();
        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return instance(originalRequest);
        }
        await logoutUser();
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export default createAxiosInstance();
